import { Component } from '@roskvartal-landings/base';
import { Modal } from '@roskvartal-landings/component-modal';

class Navbar extends Component {
  constructor(el) {
    super(el);
    const config = JSON.parse(el.dataset.config);
    const navbar = window.RK_COMPONENTS.initNavbar('navbar', config);

    navbar.$on('callbackRequest', ({ detail }) => {
      const modalElement = document.querySelector('#lead-modal');
      modalElement.dispatchEvent(Modal.getCustomOpenEvent(detail));
    });

    navbar.$on('logout', () => {
      fetch(`${config.baseLkUrl}/logout/navbar`, {
        method: 'post',
        credentials: 'include',
      }).then(() => {
        navbar.$set({
          user: null,
        });
      });
    });
  }
}

export default Navbar;
